export default __webpack_public_path__ + "static/offering5-902bea6dc21e3c005b04f582f641a25c.png";